import { render } from "./GenderPolicyModal.vue?vue&type=template&id=25fccc3a&ts=true"
import script from "./GenderPolicyModal.vue?vue&type=script&lang=ts"
export * from "./GenderPolicyModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\laragon\\www\\SDL\\blims\\blims-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__